import { render, staticRenderFns } from "./JobsCasa.vue?vue&type=template&id=482bea46&scoped=true"
import script from "./JobsCasa.vue?vue&type=script&lang=js"
export * from "./JobsCasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482bea46",
  null
  
)

export default component.exports